import thdCustomer from "@thd-olt-global/thd-customer";
import { getChannel } from "./index";
import { getCookie } from "./cookies";
import { getErrorCode } from "./errors";
import newRelic from "./newrelic";

const LoggingService = () => {

  const defaultValues = {
    global_id: "",
    user_type: "guest",
    service_request_ts: "",
    component: "SSP",
    serviceURL: "",
    request: "",
    response: "",
    responseCode: 0,
    responseTime: 0,
    http_method: "",
    x_device: "",
    user_agent: "",
    miscellaneous: "",
    featureSwitch: "true"
  };

  const request = {
    appname: "account",
    tablename: "eventlog",
    rows: [
      {
        operation: "INSERT",
        columns: { ...defaultValues }
      }
    ]
  };

  const getServiceURL = (req) =>
    (req && req.bttXhrUrl) || req.responseURL;

  function updateRequest(updatedValues) {
    request.rows[0].columns = { ...(request.rows[0].columns), ...updatedValues };
  }

  function resetRequestData() {
    request.rows[0].columns = { ...defaultValues };
  }

  function setGlobalID() {
    try {
      const THD_USER = getCookie("THD_USER");
      let THD_CUSTOMER = getCookie("THD_CUSTOMER");
      if (THD_CUSTOMER) [ THD_CUSTOMER ] = THD_CUSTOMER.split(".");
      const global_id = THD_USER || THD_CUSTOMER ||  ""; // eslint-disable-line camelcase

      if (thdCustomer.isLoggedIn) {
        updateRequest({
          global_id, miscellaneous: `${thdCustomer.userID}/${thdCustomer.svocID}`,
          user_type: thdCustomer.customerType
        });
      }

    } catch (e) {
      console.error(`Failed to set customer info for LoggingService, ${e}`); // eslint-disable-line no-console
    }
    return request;
  }

  const setServiceRequestTimestamp = () => {
    try {
      const service_request_ts = new Date().toUTCString(); // eslint-disable-line camelcase
      updateRequest({ service_request_ts });
    } catch (e) {
      console.error(`Failed to set Service Request Timestamp, ${e}`); // eslint-disable-line no-console
    }
    return request;
  };

  const setBetaFlag = () => {
    try {
      if (getCookie("HD_DC") === "beta") {
        const miscellaneous = `${request.rows[0].columns.miscellaneous} &beta`;
        updateRequest({ miscellaneous });
      }
    } catch (e) {
      console.error(`Failed to set beta flag, ${e}`); // eslint-disable-line no-console
    }
    return request;
  };

  const setThdMccId = () => {
    const THD_MCC_ID = getCookie("THD_MCC_ID");
    if (THD_MCC_ID) {
      const miscellaneous = `${request.rows[0].columns.miscellaneous};THD_MCC_ID:${THD_MCC_ID}`;
      updateRequest({ miscellaneous });
    }
  };

  const setMetadata = () => {
    setGlobalID();
    setServiceRequestTimestamp();
    updateRequest({ user_agent: navigator?.userAgent });
    setBetaFlag();
    setThdMccId();
  };

  const setApiCallInfo = (resp, responseTime) => {
    try {
      const responseCode = resp.status.toString();
      const http_method = resp.config && resp.config.method; // eslint-disable-line camelcase
      const uuid = resp.config && resp.config.headers && resp.config.headers["x-trace-uuid"];
      const serviceURL = getServiceURL(resp.request);
      const component = window.location.pathname; // eslint-disable-line no-restricted-globals
      const x_device = getChannel(); // eslint-disable-line camelcase
      updateRequest({ responseCode, http_method, component, request: uuid, serviceURL, x_device, responseTime });
    } catch (e) {
      console.error(`Failed to set API call information in LoggingService, ${e}`); // eslint-disable-line no-console
    }
    return request;
  };

  const setApiErrorInfo = (err, responseTime) => {
    try {
      const http_method = err && err.response && err.response.config.method; // eslint-disable-line camelcase
      const serviceURL = getServiceURL(err.request);
      const response = getErrorCode(err);
      const responseCode = err && err.response && err.response.status.toString();
      const component = window.location.pathname; // eslint-disable-line no-restricted-globals
      const uuid = err && err.response && err.response.config && err.response.config.headers && err.response.config.headers["x-trace-uuid"];
      const x_device = getChannel(); // eslint-disable-line camelcase

      updateRequest({ http_method, component, serviceURL, x_device, request: uuid, response: (response || "API_ERROR"), responseCode, responseTime });
    } catch (e) {
      console.error(`Failed to set API error information in LoggingService, ${e}`); // eslint-disable-line no-console
    }
    return request;
  };


  return Object.assign({}, {
    logApiCall: (resp, responseTime, customMessage) => {
      setMetadata();
      setApiCallInfo(resp, responseTime);
      if(customMessage) updateRequest({ miscellaneous: `${request.rows[0].columns.miscellaneous}--${customMessage}` });
      // No longer calling /servicelog endpoint, will rely on New Relic instead
      // loggingService(request, resetRequestData);
      newRelic.logApiResponse(request);
      resetRequestData();
    },

    logApiError: (err, responseTime) => {
      setMetadata();
      setApiErrorInfo(err, responseTime);
      // No longer calling /servicelog endpoint, will rely on New Relic instead
      // loggingService(request, resetRequestData);
      newRelic.logApiResponse(request);
      resetRequestData();
    }
  })
};

export default LoggingService();
